import { SystemSetting } from '@/api/settings';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../ui/tabs';
import { RateLimitSettingsPanel } from './RateLimitSettingsPanel';
import { SettingsList } from './SettingsList';

interface SettingsTabsProps {
  settings: SystemSetting[];
  canManage: boolean;
  isSuperAdmin: boolean;
}

export function SettingsTabs({ settings, canManage, isSuperAdmin }: SettingsTabsProps) {
  return (
    <Tabs defaultValue="system" className="w-full space-y-6">
      <div className="w-full">
        <TabsList className="!h-auto !w-full !bg-[#e5e7eb] !p-1 !rounded-xl !border !border-slate-200 shadow-sm">
          <TabsTrigger
            value="system"
            className="!h-10 !min-w-[120px] !flex-1 !px-6 !text-base !font-medium !text-slate-700 data-[state=active]:!bg-[#1e3a5f] data-[state=active]:!text-white data-[state=active]:!shadow-sm"
          >
            Sistema
          </TabsTrigger>
          <TabsTrigger
            value="security"
            className="!h-10 !min-w-[120px] !flex-1 !px-6 !text-base !font-medium !text-slate-700 data-[state=active]:!bg-[#1e3a5f] data-[state=active]:!text-white data-[state=active]:!shadow-sm"
          >
            Seguridad
          </TabsTrigger>
          <TabsTrigger
            value="ui"
            className="!h-10 !min-w-[120px] !flex-1 !px-6 !text-base !font-medium !text-slate-700 data-[state=active]:!bg-[#1e3a5f] data-[state=active]:!text-white data-[state=active]:!shadow-sm"
          >
            UI / Tema
          </TabsTrigger>
          <TabsTrigger
            value="registration"
            className="!h-10 !min-w-[120px] !flex-1 !px-6 !text-base !font-medium !text-slate-700 data-[state=active]:!bg-[#1e3a5f] data-[state=active]:!text-white data-[state=active]:!shadow-sm"
          >
            Registro
          </TabsTrigger>
          {isSuperAdmin ? (
            <TabsTrigger
              value="rate-limits"
              className="!h-10 !min-w-[120px] !flex-1 !px-6 !text-base !font-medium !text-slate-700 data-[state=active]:!bg-[#1e3a5f] data-[state=active]:!text-white data-[state=active]:!shadow-sm"
            >
              Rate Limits
            </TabsTrigger>
          ) : null}
        </TabsList>
      </div>
      <TabsContent value="system" className="mt-6">
        <SettingsList settings={settings} category="system" canManage={canManage} />
      </TabsContent>
      <TabsContent value="security" className="mt-6">
        <SettingsList settings={settings} category="security" canManage={canManage} />
      </TabsContent>
      <TabsContent value="ui" className="mt-6">
        <SettingsList settings={settings} category="ui" canManage={canManage} />
      </TabsContent>
      <TabsContent value="registration" className="mt-6">
        <SettingsList settings={settings} category="registration" canManage={isSuperAdmin} />
      </TabsContent>
      {isSuperAdmin ? (
        <TabsContent value="rate-limits" className="mt-6">
          <RateLimitSettingsPanel settings={settings} canManage={true} />
        </TabsContent>
      ) : null}
    </Tabs>
  );
}
